import React, { Component } from 'react';
import '../css/style.css';
import './Home.css';
import { Nav} from 'react-bootstrap';


class Footer extends Component {
    render(){
		
        return (
            <div  className=" bg-light navbar  justify-content-center  " >
				<Nav className="justify-content-center" activeKey="/home">
					<Nav.Item>
					<Nav.Link href="/home">Über easyEvent</Nav.Link>
					</Nav.Item>
					<Nav.Item>
					<Nav.Link href="#agb">AGB</Nav.Link>
					</Nav.Item>
					<Nav.Item>
					<Nav.Link eventKey="link-2">Datenschutz</Nav.Link>
					</Nav.Item>
					<Nav.Item>
					<Nav.Link eventKey="link-2">Impressum</Nav.Link>
					</Nav.Item>
					<Nav.Item>
					<Nav.Link eventKey="link-2">Kontakt</Nav.Link>
					</Nav.Item>
					<Nav.Item>
					</Nav.Item>
				</Nav>
		</div>
        )
    }
}

export default Footer;